import { FullSpinner } from "../LoadingSpinner";

type BBBMeetingWindowProps = {
  meetingUrl: string;
};

export default function BBBMeetingWindow(props: BBBMeetingWindowProps) {
  const { meetingUrl } = props;

  return (
    <iframe
      title="Sanad"
      key={meetingUrl}
      width="100%"
      height="100%"
      src={meetingUrl}
      allow="camera *; microphone *; fullscreen *"
      allowFullScreen
    ></iframe>
  );
}
